var map = {
	"./bivouac.svg": 621,
	"./camper_park.svg": 7383,
	"./camping.svg": 7723,
	"./parking.svg": 3910,
	"./pin.svg": 3039,
	"./services/camp_store.svg": 4568,
	"./services/camper_station.svg": 6998,
	"./services/caravan_salon.svg": 2739,
	"./services/laundry.svg": 3492,
	"./services/lpg.svg": 588,
	"./services/service.svg": 8742,
	"./services/shower.svg": 3959,
	"./services/water.svg": 4610,
	"./shed.svg": 5684,
	"./tourist_attraction.svg": 2292,
	"./tourist_attractions/archeology.svg": 8609,
	"./tourist_attractions/beach.svg": 8703,
	"./tourist_attractions/bike.svg": 7041,
	"./tourist_attractions/brewery.svg": 3960,
	"./tourist_attractions/bridge.svg": 869,
	"./tourist_attractions/building.svg": 5366,
	"./tourist_attractions/bunker.svg": 9985,
	"./tourist_attractions/cable_car.svg": 5958,
	"./tourist_attractions/canyon.svg": 6782,
	"./tourist_attractions/car_overlook.svg": 7868,
	"./tourist_attractions/castle.svg": 502,
	"./tourist_attractions/cave.svg": 1705,
	"./tourist_attractions/cementary.svg": 5732,
	"./tourist_attractions/church.svg": 3847,
	"./tourist_attractions/church_wood.svg": 1277,
	"./tourist_attractions/city.svg": 7827,
	"./tourist_attractions/cross.svg": 5866,
	"./tourist_attractions/dam.svg": 7168,
	"./tourist_attractions/horse.svg": 1937,
	"./tourist_attractions/kayak.svg": 1779,
	"./tourist_attractions/lake.svg": 9047,
	"./tourist_attractions/lighthouse.svg": 6062,
	"./tourist_attractions/marina.svg": 4128,
	"./tourist_attractions/monument.svg": 7301,
	"./tourist_attractions/mountain.svg": 6623,
	"./tourist_attractions/museum.svg": 2050,
	"./tourist_attractions/overlook.svg": 5213,
	"./tourist_attractions/palace.svg": 7710,
	"./tourist_attractions/park.svg": 5346,
	"./tourist_attractions/quarry.svg": 2338,
	"./tourist_attractions/restaurant.svg": 503,
	"./tourist_attractions/ski.svg": 3685,
	"./tourist_attractions/stones.svg": 192,
	"./tourist_attractions/swimming_pool.svg": 1510,
	"./tourist_attractions/technical.svg": 5699,
	"./tourist_attractions/theme_park.svg": 6419,
	"./tourist_attractions/thermae.svg": 5094,
	"./tourist_attractions/ticket.svg": 2566,
	"./tourist_attractions/tower.svg": 6233,
	"./tourist_attractions/train.svg": 3972,
	"./tourist_attractions/trekking.svg": 3557,
	"./tourist_attractions/tunnel.svg": 7480,
	"./tourist_attractions/underground_path.svg": 5073,
	"./tourist_attractions/urbex.svg": 4844,
	"./tourist_attractions/village.svg": 206,
	"./tourist_attractions/waterfall.svg": 4236,
	"./tourist_attractions/windmill.svg": 5586,
	"./tourist_attractions/wine.svg": 5125,
	"./tourist_attractions/zoo.svg": 5486,
	"./wild.svg": 5770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1468;